import { ChangeEvent } from "react";
import ShapeInterface from "../../Interfaces/ShapeInterface"

import { Field, useFormikContext } from 'formik';

import { updateShapeValues } from "../../Helpers/FormikUpdateFunctions";
import { getImageSizes, getSrcSet } from "../../Helpers/WindowHelpers";

interface ShapeProps {
    shape: ShapeInterface,
    disabled?: boolean
}

const Shape = ({ shape, disabled }: ShapeProps) => {
    const context = useFormikContext<any>();
    const image = shape.shape_id == context.values?.shape ? shape.selected_icon : shape.icon
    return (
        <div className="configurator-shapes__shape">
            <label className="ratio ratio--square" aria-label={image.alt}>
                <Field
                    type="radio"
                    checked={shape.shape_id == context.values?.shape}
                    name="shape"
                    value={shape.shape_id}
                    className={"configurator-shapes__input visually-hidden"}
                    disabled={disabled}
                    onChange={(e: ChangeEvent) => {
                        if (disabled) return;
                        updateShapeValues((e.currentTarget as HTMLInputElement).value, context, true);
                    }}
                />
                <img
                    className="d--block ratio__content ratio__content--cover"
                    srcSet={getSrcSet(image.src, [80, 160])}
                    sizes={getImageSizes('80px', [])}
                    alt={image.alt}
                    loading="lazy"
                    role="presentation"
                />
            </label>
        </div>
    )
}

export default Shape
